import { render, staticRenderFns } from "./WorkerManagement.vue?vue&type=template&id=0da56877&scoped=true"
import script from "./WorkerManagement.vue?vue&type=script&lang=js"
export * from "./WorkerManagement.vue?vue&type=script&lang=js"
import style0 from "./WorkerManagement.vue?vue&type=style&index=0&id=0da56877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da56877",
  null
  
)

export default component.exports